<template>
  <div v-loading="loading" class="cart-page">
    <div class="cart-header">
      <h2>购物车</h2>
      <i class="el-icon-refresh" @click="getData"/>
    </div>

    <div v-if="cartList.length === 0" class="empty-cart">
      <el-empty description="购物车为空"/>
    </div>

    <el-table
        v-else
        :data="cartList"
        style="width: 100%"
        border
        stripe
        @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"/>
      <el-table-column type="index" label="序号" width="50" align="center"/>
      <el-table-column prop="materialName" label="产品名称" min-width="300"/>
      <el-table-column prop="updateTime" label="更新时间" align="center" width="140"/>
      <el-table-column label="价格" prop="price" width="120" align="right">
        <template slot-scope="scope">
          ¥ <span class="price">{{commonUtil.formatNumberToLocale((parseFloat(scope.row.price) * parseFloat(scope.row.quantity)).toFixed(2))}}</span>
        </template>
      </el-table-column>
      <el-table-column label="数量" width="180" align="center">
        <template slot-scope="scope">
          <el-input-number
              v-model="scope.row.quantity"
              :min="1"
              size="small"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-link type="primary" @click="editCart(scope.row)">编辑</el-link>
          <el-link type="danger" @click="removeFromCart(scope.row.pkid)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="cartList-total">
      总计： ¥ <span class="price">{{commonUtil.formatNumberToLocale(totalPrice.toFixed(2))}}</span> 
    </div>
    <div v-if="cartList.length > 0" class="cart-actions">
      <el-button type="danger" @click="removeFromCart(0)">批量删除</el-button>
      <el-button type="primary" plain @click="createOrder(70)">改造订单</el-button>
      <el-button type="primary" @click="createOrder(0)">非改造订单</el-button>
    </div>
    <order-edit ref="orderEdit" @save-success="getData"/>
    <product-add-to-cart ref="productAddToCart"/>
  </div>
</template>

<script>
  import OrderEdit from "../order/OrderEdit.vue";
  import ProductAddToCart from "@/views/main/components/ProductAddToCart.vue";
  import commonUtil from "@/util/commonUtil";
  import { EventBus } from "@/util/eventBus";
  export default {
    name: "Cart",
    components: { OrderEdit, ProductAddToCart },
    data() {
      return {
        loading: false,
        cartList: [],
        multipleSelection: [],
        commonUtil,
      };
    },
    computed: {
      totalPrice() {
        let total = 0;
        this.multipleSelection.forEach(item => {
          total += parseFloat(item.price) * parseFloat(item.quantity);
        });
        return total;
      },
    },
    mounted() {
      this.getData();
      // 添加一个监听是否添加购物车成功的事件，然后刷新购物车列表
      EventBus.$on("cart-list-refresh", this.getData);
    },
    beforeDestroy() {
      // 移除事件监听
      EventBus.$off("cart-list-refresh", this.getData);
    },
    methods: {
      getData() {
        this.loading = true;
        this.$http.get("basic", "sdShoppingcarts").then(res => {
          this.cartList = res.records || [];
        }).finally(() => {
          this.loading = false;
        });
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      createOrder(orderType) {
        if (this.multipleSelection.length === 0) {
          this.$message.warning("请选择要生成订单的商品");
          return;
        }
        const selectedIds = this.multipleSelection.map(item => item.pkid);
        this.$refs.orderEdit.open({ cartIds: selectedIds, orderType, cartList: this.multipleSelection });
      },
      // 删除购物车列表
      removeFromCart(pkid) {
        let ids = "";
        if(pkid) {
          ids = [pkid];
        } else {
          // 检查是否有选中的商品
          if (this.multipleSelection.length === 0) {
            this.$message.warning("请选择要删除的商品");
            return;
          }
          ids = this.multipleSelection.map(item => item.pkid);
        }
        // 确认删除
        this.$confirm("确定删除该商品吗？", "删除确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$http.get("basic", `sdShoppingcarts/del/${ids}`).then(res => {
            if (res.success) {
              this.$message.success("删除成功");
              this.getData();
            } else {
              this.$message.error("删除失败");
            }
          });
        });
      },
      // 编辑购物车列表
      editCart(row) {
        this.$refs.productAddToCart.openByCartId(row);
      },
      // 表格合计
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          }
          if (["price"].includes(column.property)) {
            const values = data.map(item => Number(item[column.property]) * parseFloat(item.quantity));
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = "¥ " + commonUtil.formatNumberToLocale(parseFloat(sums[index]).toFixed(2));
          } else {
            sums[index] = "";
          }
        });

        return sums;
      },
    },
  };
</script>

<style lang="scss" scoped>
.cart-page {
  padding: 20px;
  .price{
    font-weight: bold;
    color: #F56C6C;
  }
  .cart-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    h2 {
      font-size: 24px;
      color: #333;
    }
    .el-icon-refresh {
      cursor: pointer;
      font-size: 24px;
      margin-left: 10px;
      color: #2D8CF0;
    }
  }
  .empty-cart {
    margin: 100px 0;
    text-align: center;
  }
  .cartList-total{
    text-align: right;
    padding-top: 20px;
    font-size: 14px;
  }
  .cart-actions {
    margin-top: 10px;
    text-align: right;

    .el-button {
      margin-left: 10px;
    }
  }
  ::v-deep .el-table__footer {
    font-weight: bold;
  }
}
</style>
